import { render, staticRenderFns } from "./RegisterOnPublic.vue?vue&type=template&id=5db181e8&scoped=true&"
import script from "./RegisterOnPublic.vue?vue&type=script&lang=js&"
export * from "./RegisterOnPublic.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOnPublic.vue?vue&type=style&index=0&id=5db181e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db181e8",
  null
  
)

export default component.exports